"use client";

import WaveBanner from "@/app/components/footer/components/WaveBanner";
import Logo from "@/app/components/logos/tiber/Logo";
import { darken, Stack, useMantineTheme } from "@mantine/core";
import classes from "./auth-content.module.css";
import AnimatedBackground from "./AnimatedBackground";

export const useAuthStyles = () => ({ classes });

export default function AuthContentWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const theme = useMantineTheme();

  return (
    <>
      <div className={classes.pageWrapper}>
        <AnimatedBackground />
        <Stack className={classes.contentWrapper}>
          <Logo className={classes.logo} />
          <div className={classes.borderWrapper}>{children}</div>
        </Stack>
      </div>
      <WaveBanner
        colors={{
          light: "white",
          dark: darken(theme.colors.darkblue[9], 0.4),
        }}
      />
    </>
  );
}
